export default __webpack_public_path__ + "static/media/light@2x.15cfbd3a.png";